import { strings } from '@constants'
class EnquirySupplierQuote {
	constructor() {
		this.supplier = null
		this.dispatch_location = null
		this.order_given = false
		this.quote_type = strings('for') //x or for
		this.minimum_order_quantity = 0
		this.minimum_guaranteed_weight = 0
		this.quote_valid_till = new Date().getTime()
		this.logistics_quote = 0
		this.total_quotation_amount = 0
		this.supplier_quote = []
		this.message = null
		this.lumpsum_logistics_quote = 0
		this.by_admin = true
		this.quote_accepted_buyer = null
		this.quote_accepted_supplier = null
		this.is_requested_supplier = null
		this.billing_address = null
		this.payment_terms_list = null
		this.other_charges = null
		this.show_buyer_name = false
		this.terms =
			'1. PRICES ARE F.O.R AT SITE AND EXCLUSIVE OF TAXES\n2. ENDORSED TEST CERTIFICATES TO BE PROVIDED BEFORE DISPATCH\n3. WEIGHT TOLERANCE :- +/- 0.5% OF INVOICED WEIGHT\n4. DELIVERY CONDITIONS :- IMMEDIATE\n5. TCS IS NOT APPLICABLE, TDS TO BE CHARGED WHILE MAKING THE PAYMENT AGAINST THE BILLS.\n6. UNLOADING EXTRA UNDER THE SCOPE OF THE BUYER\n'
		this.oracle_order_in_kgs = false
	}
}

export default EnquirySupplierQuote
